export const LOADING_DATA_STARTED = "LOADING_DATA_STARTED";
export const DATA_LOADED = "DATA_LOADED";
export const LOADING_DATA_FINISHED = "LOADING_DATA_FINISHED";
